/* eslint-disable @typescript-eslint/camelcase */
import { AppService } from './AbstractService';

export default class PromotionService extends AppService {
  public async checkTurnover() {
    return this.makeRequest('GET', '/promotions/turnover');
  }

  public async acceptPromotion(data: any) {
    return this.makeRequest('POST', '/promotions/join', data);
  }

  public async clearFortunewheelTurnover() {
    return this.makeRequest('POST', '/promotions/clear-fortune-turnover');
  }
}
